/**
 * Main Entry Point for React App
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Fragno is not imported here: it loads only with fragnoLogoEnabled, once
// IDME_INIT arrives. See src/shared/fragno/loadFragno.ts.
import "./styles/index.scss";
import { SentryWrapper } from "./components/SentryWrapper";
import { markBooted } from "./boot/assetRecovery";

// Initialize i18n
import "./lib/i18n";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryWrapper>
      <App />
    </SentryWrapper>
  </React.StrictMode>
);

markBooted(window);
